import { createSelector } from 'reselect';

const getCustomerDetails = (state, adfitNo) =>
  state.customerDetails &&
  (state.customerDetails.adfitNo === adfitNo ? state.customerDetails : null);

const getFacilities = (state) => state.facilities.entities;

export const makeSelectFacilityByAdfitNo = () => {
  return createSelector(
    [getCustomerDetails, getFacilities],
    (account, facilities) => {
      if (!account) return null;
      const { facility: facilityId } = account;
      return facilities[facilityId];
    }
  );
};
